import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { EnvioAduanasV3Service } from './envioaduanav3.service';
import { EnvioAduanasV3ItemViewModel } from './envioaduanav3.types';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';

@Component({
    selector: 'app-envioaduanav3-edit',
    templateUrl: './envioaduanav3-edit.component.html',
})
export class EnvioAduanasV3EditComponent extends ComponentBase implements OnInit {
    envioAduanasV3: EnvioAduanasV3ItemViewModel;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: FormBuilder,
        private envioAduanasV3Service: EnvioAduanasV3Service,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);

        this.envioAduanasV3 = new EnvioAduanasV3ItemViewModel();
    }

    ngOnInit() {
        this.createForm();

        let id = +this.activatedRoute.snapshot.params['id'];

        if (id) {
            this.envioAduanasV3Service.getWEnvioAduanasV3(id).subscribe(result => {
                this.envioAduanasV3 = result;
                this.updateForm();
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            IdSolicitud: '',
            CodigoSolicitud: '',
            FechaInicioCompleta: '',
            FechaCompleta: '',
            Duracionms: '',
            Funcion: '',
            EstadoEnvioAduanas: '',
            Respuesta: '',
            DescripcionError: '',
            SoapRequest: '',
            SoapResponse: '',
        });
    }

    updateForm() {
        this.form.setValue({
            IdSolicitud: this.envioAduanasV3.IdSolicitud,
            CodigoSolicitud: this.envioAduanasV3.CodigoSolicitud,
            FechaInicioCompleta: this.envioAduanasV3.FechaInicioCompleta,
            FechaCompleta: this.envioAduanasV3.FechaCompleta,
            Duracionms: this.envioAduanasV3.Duracionms,
            Funcion: this.envioAduanasV3.Funcion,
            EstadoEnvioAduanas: this.envioAduanasV3.EstadoEnvioAduanas,
            Respuesta: this.envioAduanasV3.Respuesta,
            DescripcionError: this.envioAduanasV3.DescripcionError,
            SoapRequest: this.envioAduanasV3.SoapRequest,
            SoapResponse: this.envioAduanasV3.SoapResponse,
        });
    }

    onSubmit() {}

    onCopiarRespuesta(inputElement: any) {
        inputElement.select();
        document.execCommand('copy');
        inputElement.setSelectionRange(0, 0);
    }

    onCopiarError(inputElement: any) {
        inputElement.select();
        document.execCommand('copy');
        inputElement.setSelectionRange(0, 0);
    }

    onCopiarSoapRequest(inputElement: any) {
        inputElement.select();
        document.execCommand('copy');
        inputElement.setSelectionRange(0, 0);
    }

    onCopiarSoapResponse(inputElement: any) {
        inputElement.select();
        document.execCommand('copy');
        inputElement.setSelectionRange(0, 0);
    }

    onBack() {
        this.router.navigate(['/mantenimiento/envios/aduanasv3']);
    }
}
